import React, {useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import BlockAccessPage from '../../components/BlockAccess/BlockAccessPage';
import PageContent from '../../components/PageContent/PageContent';
import MainTableTitle from '../../components/Table/Utils/MainTableTitle';
import Tabs from '../../components/Tabs/Tabs';
import TranslatedText from '../../libraries/I18N/TranslatedText';
import {accessModule} from '../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../utils/SubscriptionHelper';

import CADocument from './Components/CADocument';
import ESGDocument from './Components/ESGDocument';

const AIDocumentManager: React.FC = () => {
  const [searchParam] = useSearchParams();
  const [activeKey, setActiveKey] = useState<string>(
    searchParam.get('tab') ?? ''
  );

  const tabDetails = [
    {
      id: 'Carbon_Accounting',
      name: <TranslatedText translationKey="Carbon Accounting" />,
      component: shouldBlockModuleAccess(accessModule.AIDocumentManager) ? (
        <BlockAccessPage />
      ) : (
        <CADocument />
      ),
      hidden: false
    },
    {
      id: 'ESG_Reporting',
      name: <TranslatedText translationKey="ESG Reporting" />,
      component: shouldBlockModuleAccess(accessModule.AIDocumentManager) ? (
        <BlockAccessPage />
      ) : (
        <ESGDocument />
      ),
      hidden: false
    }
  ].filter((item) => !item.hidden);

  return (
    <PageContent fullscreen={false}>
      <MainTableTitle title="AI Document Manager" />
      <Tabs
        array={tabDetails}
        noPadding
        fullWidth={false}
        activeKey={activeKey}
        setActiveKey={setActiveKey}
      />
    </PageContent>
  );
};

export default AIDocumentManager;
